/** @format */

import React, { FC, useState, useEffect } from 'react'
import styled from 'styled-components'
import { _$, Form, FormItem, Button, Select, Option } from '@king-design/react'
// import { Select, Option } from '@king-design/react'

import { HeaderFormValues } from './constants'
interface DataSourceProps {
  className?: string
  sourceOption: any[]
  deviceOptions: any[]
  allnode_loading: boolean
  formValues: HeaderFormValues
  setFormValues: (values: HeaderFormValues) => void
}

const DataSource: FC<DataSourceProps> = ({
  className,
  sourceOption,
  deviceOptions,
  allnode_loading,
  formValues,
  setFormValues
}) => {
  const [device, setDevice] = useState<string[]>([])
  useEffect(() => {
    setDevice(formValues.device)
  }, [formValues.device])

  return !allnode_loading ? (
    <Form className={className} layout="inline">
      <FormItem label={_$('数据源')}>
        <Select
          width={150}
          value={formValues.dataSource}
          onChangeValue={value => {
            setFormValues({
              dataSource: value,
              device: []
            })
          }}
        >
          {sourceOption?.length
            ? sourceOption.map(({ ClusterID, ClusterName }) => (
                <Option key={ClusterID} value={ClusterID}>
                  {ClusterName}
                </Option>
              ))
            : null}
        </Select>
      </FormItem>
      <FormItem className="device-form-item" label={_$('设备')}>
        <Select
          className="king-select"
          value={device}
          width={600}
          multiple
          filterable
          clearable
          nowrap
          onChangeValue={value => {
            setDevice(value)
          }}
        >
          {deviceOptions?.map(({ label, value }) => (
            <Option key={value} value={value}>
              {label}
            </Option>
          ))}
        </Select>
      </FormItem>
      <FormItem hideLabel>
        <Button
          type="primary"
          onClick={() => {
            setFormValues({
              ...formValues,
              device
            })
          }}
        >
          {_$('查询')}
        </Button>
        <Button
          onClick={() => {
            setDevice([])
            setFormValues({
              ...formValues,
              device: []
            })
          }}
        >
          {_$('重置')}
        </Button>
      </FormItem>
    </Form>
  ) : null
}

export default styled(DataSource)`
  padding: 16px 0 0;
  .k-form-item {
    margin-bottom: 0px;
  }
  .k-btn.k-primary {
    margin-right: 8px;
  }
`
